import React, { useState } from "react";
import { AppBar, Toolbar, Typography, IconButton, Box, Menu, MenuItem } from "@mui/material";
import { Link } from "react-router-dom";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIcon from "@mui/icons-material/Phone";
import MenuIcon from "@mui/icons-material/Menu";

function Header() {
  const [anchorEl, setAnchorEl] = useState(null);
  const navLinks = [
    { to: "/", label: "INICIO" },
    //{ to: "/catalogo", label: "CATÁLOGO" },
    { to: "/sobre", label: "SOBRE NOSOTROS" },
    { to: "/ayuda", label: "CÓMO AYUDAR" },
    { to: "/adopcion", label: "ADOPCIÓN" },
    { to: "/actividades", label: "ACTIVIDADES" },
    { to: "/contacto", label: "CONTACTO" },
  ];

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  return (
    <AppBar position="static" color="transparent" elevation={0}>
      <Toolbar sx={{ display: "flex", justifyContent: "space-between" }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img src="/images/logo.png" alt="BisbalGat" style={{ height: 60 }} />
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1, color: "gray" }}>
          <IconButton color="inherit" href="tel:+34618293661" sx={{ fontSize: 18 }}>
            <PhoneIcon fontSize="small" />
          </IconButton>
          <Typography variant="body2" sx={{ fontSize: 14, fontFamily: "'Bitter', serif" }}>
            +34 618 293 661
          </Typography>
          <IconButton color="inherit" href="mailto:bisbalgat@yahoo.com" sx={{ fontSize: 18}}>
            <EmailIcon fontSize="small" />
          </IconButton>
          <Typography variant="body2" sx={{ fontSize: 14 }}>
            bisbalgat@yahoo.com
          </Typography>
        </Box>
      </Toolbar>
      <Toolbar sx={{ justifyContent: "flex-end", gap: 3 }}>
        <Box
          sx={{
            display: { xs: "none", md: "flex" },
            gap: 3,
          }}
        >
          {navLinks.map(({ to, label }) => (
            <Link
              key={to}
              to={to}
              style={{ textDecoration: "none", color: "#8A7FAF", textTransform: "uppercase", fontWeight: "bold" }}
            >
              {label}
            </Link>
          ))}
        </Box>
        <Box sx={{ display: { xs: "flex", md: "none" } }}>
          <IconButton color="inherit" onClick={handleMenuOpen}>
            <MenuIcon sx={{ color: "#8A7FAF" }} />
          </IconButton>
          <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleMenuClose}
            keepMounted
          >
            {navLinks.map(({ to, label }) => (
              <MenuItem
                key={to}
                component={Link}
                to={to}
                onClick={handleMenuClose}
                sx={{ color: "#8A7FAF", textTransform: "uppercase", fontWeight: "bold" }}
              >
                {label}
              </MenuItem>
            ))}
          </Menu>
        </Box>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
